import { TextField as MuiTextField } from '@mui/material';
import { spacing } from '@mui/system';
import styled from 'styled-components';

export const TextField = styled(MuiTextField)<{ my?: number }>(spacing);
